import React from 'react'
import Button from 'react-bootstrap/Button'
import GuestListModal from './GuestListModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserFriends } from '@fortawesome/free-solid-svg-icons'
import { showModal } from '../../redux/ui/actions'
import { useDispatch, useSelector } from 'react-redux'
import { isEventAdmin } from '../../redux/state'

export const GuestListButton = props => {
  const dispatch = useDispatch()

  const { variant, id, mode, className, size } = props

  const authorised = useSelector(state => isEventAdmin(state, id))

  if (!authorised) return null

  const handleClick = e => {
    e.stopPropagation()
    dispatch(showModal('guestlist-events', id, true))
    if (props.handleClick) {
      props.handleClick(e)
    }
  }

  const label = 'Guest list'

  if (mode === 'icon') {
    return (
      <React.Fragment>
        <button
          title={label}
          onClick={handleClick}
          className={className}>
          <FontAwesomeIcon icon={faUserFriends} />
        </button>
        <GuestListModal
          id={id}
          resource="events"
        />{' '}
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Button
        variant={variant || 'light'}
        title={label}
        onClick={handleClick}
        className={className}
        size={size}>
        <FontAwesomeIcon
          icon={faUserFriends}
          className="me-2"
        />
        <span className="text-nowrap">{label}</span>
      </Button>
      <GuestListModal
        id={id}
        resource="events"
      />{' '}
    </React.Fragment>
  )
}

export default GuestListButton
